import gql from 'graphql-tag'

export const CREATE_PRESET = gql`
  mutation CreatePreset($data: PresetCreateInput!, $cover: Upload) {
    createPreset(data: $data, cover: $cover) {
      id
      name
    }
  }
`

export const UPDATE_PRESET = gql`
  mutation UpdatePreset($id: Int!, $data: PresetUpdateInput!, $cover: Upload) {
    updatePreset(id: $id, data: $data, cover: $cover) {
      id
      name
    }
  }
`

export const DELETE_PRESET = gql`
  mutation DeletePreset($id: Int!) {
    deletePreset(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/Preset.js